const MAX_LINES = 5;
/**
 * Limits transport lines across groups to a maximum number of lines.
 * Returns the limited groups and the number of excess lines.
 */
export const getTransportLinesWithLimit = (groups, maxLines = MAX_LINES) => {
    const { limitedGroups, includedLines } = groups.reduce((acc, group) => {
        if (acc.remainingLines <= 0)
            return acc;
        const linesToInclude = Math.min(group.lines.length, acc.remainingLines);
        return {
            limitedGroups: [
                ...acc.limitedGroups,
                Object.assign(Object.assign({}, group), { lines: group.lines.slice(0, linesToInclude) }),
            ],
            includedLines: acc.includedLines + linesToInclude,
            remainingLines: acc.remainingLines - linesToInclude,
        };
    }, {
        limitedGroups: [],
        includedLines: 0,
        remainingLines: maxLines,
    });
    const totalLines = groups.reduce((sum, group) => sum + group.lines.length, 0);
    return {
        limitedGroups,
        excessLineCount: Math.max(0, totalLines - includedLines),
    };
};
